module.exports = __webpack_public_path__ + "static/media/Character.541daaf9.svg";